export const isKeyPressed = (eventKey: string, keyToMatch: string): boolean =>
  eventKey === keyToMatch ? true : false;
